const isAndroidPOS = () => {
  return (
    typeof window !== 'undefined' &&
    window.AndroidPOS &&
    typeof window.AndroidPOS.isAndroidPOS === 'function' &&
    window.AndroidPOS.isAndroidPOS() === true
  );
};


const getOfflineMenuCategories = () => {

  return new Promise((resolve, reject) => {

    if (!isAndroidPOS()) {
      reject(
        new Error(
          'Android POS bridge unavailable'
        )
      );
      return;
    }

    const requestId =
      `menu_categories_${Date.now()}_${Math.random()
        .toString(36)
        .substring(2, 10)}`;

    if (!window.__orderArtOfflineCallbacks) {
      window.__orderArtOfflineCallbacks = {};
    }

    window.__orderArtOfflineCallbacks[
      requestId
    ] = {
      resolve,
      reject
    };

    window.AndroidPOS.getOfflineMenuCategories(
      requestId
    );

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[
          requestId
        ]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            'Offline menu categories timeout'
          )
        );
      }

    }, 10000);
  });
};


const getOfflineMenuProducts = () => {

  return new Promise((resolve, reject) => {

    if (!isAndroidPOS()) {
      reject(
        new Error(
          'Android POS bridge unavailable'
        )
      );
      return;
    }

    const requestId =
      `menu_products_${Date.now()}_${Math.random()
        .toString(36)
        .substring(2, 10)}`;

    if (!window.__orderArtOfflineCallbacks) {
      window.__orderArtOfflineCallbacks = {};
    }

    window.__orderArtOfflineCallbacks[
      requestId
    ] = {
      resolve,
      reject
    };

    window.AndroidPOS.getOfflineMenuProducts(
      requestId
    );

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[
          requestId
        ]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            'Offline menu products timeout'
          )
        );
      }

    }, 10000);
  });
};


const getOfflineMenuProduct = (
  productId
) => {

  return new Promise((resolve, reject) => {

    if (!isAndroidPOS()) {
      reject(
        new Error(
          'Android POS bridge unavailable'
        )
      );
      return;
    }

    const requestId =
      `menu_product_${Date.now()}_${Math.random()
        .toString(36)
        .substring(2, 10)}`;

    if (!window.__orderArtOfflineCallbacks) {
      window.__orderArtOfflineCallbacks = {};
    }

    window.__orderArtOfflineCallbacks[
      requestId
    ] = {
      resolve,
      reject
    };

    window.AndroidPOS.getOfflineMenuProduct(
      requestId,
      String(productId)
    );

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[
          requestId
        ]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            `Offline product timeout: ${productId}`
          )
        );
      }

    }, 10000);
  });
};


export {
  getOfflineMenuCategories,
  getOfflineMenuProducts,
  getOfflineMenuProduct
};